// prettier-ignore
const getUrlFailSafe = (url, format = false) => {
    let returnValue = url

    if (url && url.length) {
        if (format) {
            returnValue = url.replace('http://', '').replace('https://', '')
        }
    } else {
        console.error("Property 'url' was null or blank, all results should contain a valid URL")

        if (format) {
            returnValue = 'Error: URL not found'
        } else {
            returnValue = ''
        }
    }

    return returnValue
}

const template = (data) => {
    return `<a href="${getUrlFailSafe(data.url)}" class="result">
    <h2 class="result__heading heading--4">${data.title}</h2>
    <span class="result__url">${getUrlFailSafe(data.url, true)}</span>
    <div class="result__copy">
        <p>${data.description || ''}</p>
    </div>
</a>`
}
export default template
